// web-vite/src/app/store.ts
//
// Redux store for TagBoard web. Phase 3 V1 is read-only, so the store stays
// thin — it doesn't import any TagBoard mobile slices (those depend on the
// repository pattern + SQLite, which is mobile-only).
//
// As screens grow, add per-feature slices here (e.g. a filter/search slice
// for the Tag Board grid). Server data lives in component state via
// useSupabaseSubscription — not in Redux — so the store doesn't become a
// cache of cache of cache.

import {configureStore, createSlice} from '@reduxjs/toolkit'

// Placeholder slice so the store has at least one reducer at boot. Replace
// when the first real slice arrives.
const appSlice = createSlice({
  name: 'app',
  initialState: {ready: false},
  reducers: {
    setReady(state, action: {payload: boolean}) {
      state.ready = action.payload
    },
  },
})

export const {setReady} = appSlice.actions

export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
